import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Upload, Palette, Mail, FileText, Fingerprint } from 'lucide-react';

export const BrandingSection = () => {
  return (
    <Card className="bg-gray-800/20 border-gray-700 text-white">
      <CardHeader>
        <CardTitle className="text-2xl">Corporate Branding</CardTitle>
        <CardDescription className="text-gray-400">
          Personalisieren Sie Ihre Kommunikation mit benutzerdefinierten Markeneinstellungen
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div>
          <h3 className="text-xl font-medium mb-3">Markenidentität</h3>
          <p className="text-gray-300 leading-relaxed">
            Vibemail ermöglicht es Ihnen, Ihre Unternehmensidentität in allen generierten Dokumenten und E-Mail-Vorlagen zu reflektieren. 
            Von Logos über Farbpaletten bis hin zu Kontaktinformationen - personalisieren Sie Ihre Kommunikation vollständig.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium mb-3">Anpassungsmöglichkeiten</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-gray-700/30 p-4 rounded-md">
              <div className="flex items-center gap-3 mb-2">
                <Upload className="h-5 w-5 text-jade" />
                <h4 className="font-medium text-white">Logo-Upload</h4>
              </div>
              <p className="text-sm text-gray-400">
                Laden Sie Ihr Unternehmenslogo hoch, das automatisch in E-Mails und Dokumenten verwendet wird.
              </p>
            </div>
            <div className="bg-gray-700/30 p-4 rounded-md">
              <div className="flex items-center gap-3 mb-2">
                <Palette className="h-5 w-5 text-jade" />
                <h4 className="font-medium text-white">Farbpalette</h4>
              </div>
              <p className="text-sm text-gray-400">
                Definieren Sie Ihre Markenfarben für eine konsistente visuelle Identität.
              </p>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-xl font-medium mb-3">Wo werden Branding-Einstellungen angewendet?</h3>
          <ul className="space-y-3 text-gray-300">
            <li className="flex items-start">
              <div className="bg-jade/10 p-1 rounded-full mt-1 mr-3">
                <Mail className="h-4 w-4 text-jade" />
              </div>
              <div>
                <span className="font-medium text-white">E-Mail-Vorlagen</span>
                <p className="text-sm text-gray-400 mt-1">
                  Ihr Logo, Ihre Farben und Kontaktinformationen werden automatisch in generierten E-Mail-Vorlagen integriert.
                </p>
              </div>
            </li>
            <li className="flex items-start">
              <div className="bg-jade/10 p-1 rounded-full mt-1 mr-3">
                <FileText className="h-4 w-4 text-jade" />
              </div>
              <div>
                <span className="font-medium text-white">Angebotsgenerierung</span>
                <p className="text-sm text-gray-400 mt-1">
                  Generierte Angebote und Vergleichsdokumente spiegeln Ihre Markenidentität wider.
                </p>
              </div>
            </li>
            <li className="flex items-start">
              <div className="bg-jade/10 p-1 rounded-full mt-1 mr-3">
                <Fingerprint className="h-4 w-4 text-jade" />
              </div>
              <div>
                <span className="font-medium text-white">Digitale Signaturseiten</span>
                <p className="text-sm text-gray-400 mt-1">
                  Signaturanfragen und -dokumente tragen Ihre Markenidentität.
                </p>
              </div>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-xl font-medium mb-3">Wie konfigurieren Sie Ihr Branding?</h3>
          <ol className="space-y-4 text-gray-300">
            <li className="flex items-center gap-2">
              <div className="bg-gray-700 rounded-full h-6 w-6 flex items-center justify-center text-xs text-white">1</div>
              <span>Gehen Sie zu "Einstellungen" in Ihrem Konto</span>
            </li>
            <li className="flex items-center gap-2">
              <div className="bg-gray-700 rounded-full h-6 w-6 flex items-center justify-center text-xs text-white">2</div>
              <span>Wählen Sie den Reiter "Branding"</span>
            </li>
            <li className="flex items-center gap-2">
              <div className="bg-gray-700 rounded-full h-6 w-6 flex items-center justify-center text-xs text-white">3</div>
              <span>Laden Sie Ihr Logo hoch und definieren Sie Ihre Unternehmensfarben</span>
            </li>
            <li className="flex items-center gap-2">
              <div className="bg-gray-700 rounded-full h-6 w-6 flex items-center justify-center text-xs text-white">4</div>
              <span>Fügen Sie zusätzliche Kontaktinformationen hinzu</span>
            </li>
          </ol>
        </div>

        <div>
          <h3 className="text-xl font-medium mb-3">Vorteile von Corporate Branding</h3>
          <div className="space-y-3 text-gray-300">
            <p>
              • Konsistente Darstellung Ihrer Marke in allen Kommunikationskanälen
            </p>
            <p>
              • Professionelles und einheitliches Erscheinungsbild
            </p>
            <p>
              • Stärkung der Markenidentität und -wahrnehmung
            </p>
            <p>
              • Erhöhte Wiedererkennbarkeit bei Kunden
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
